export default {
  ROUTER_LOCATION_CHANGED: "@@router/LOCATION_CHANGE",
  AUTH_LOGIN_SUCCESS: {
    category: "Auth",
    action: "Login",
    label: "Login",
    eventDataOne: "user.name",
  },
  AUTH_INVALID_LOGIN_ATTEMPT: {
    category: "Auth",
    action: "Invalid login attempt",
    label: "Login",
    eventDataOne: "user.name",
  },
  AUTH_LOGOUT_SUCCESS: {
    category: "Auth",
    action: "Logout",
    label: "Logout",
    eventDataOne: "user.name",
  },
  AUTH_SIGN_UP_SUCCESS: {
    category: "Auth",
    action: "Sign Up",
    label: "Sign Up",
    eventDataOne: "user.name",
  },
  AUTH_INVALID_SIGN_UP_ATTEMPT: {
    category: "Auth",
    action: "Invalid sign Up attempt",
    label: "Sign Up",
    eventDataOne: "user.name",
  },
  PURCHASE_SUCCESS: {
    category: "Purchase",
    action: "Buy",
    label: "Buy",
    eventDataOne: "user.name",
  },
  PAGE_ERROR: {
    category: "Errors",
    action: "Page Error",
    label: "Page Error",
    eventDataOne: "user.name",
  },
};
